// Loads the LiveKit client and the shared meeting room (public/vendor) on first use, so pages that never open a
// meeting don't download ~600 KB.
const SCRIPTS = ["/vendor/livekit-client-2.22.3.umd.js", "/vendor/meeting-room.js"];

let loading = null;

function load(src) {
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = src;
    s.async = false;
    s.onload = resolve;
    s.onerror = () => reject(new Error("تعذر تحميل ملفات الميتنج"));
    document.head.appendChild(s);
  });
}

export function loadMeetingRoom() {
  if (window.ManasaMeetingRoom && window.LivekitClient) return Promise.resolve(window.ManasaMeetingRoom);
  if (!loading) {
    loading = SCRIPTS.reduce((p, src) => p.then(() => load(src)), Promise.resolve())
      .then(() => window.ManasaMeetingRoom)
      .catch((e) => {
        loading = null;
        throw e;
      });
  }
  return loading;
}
